import { Checkbox, FormControlLabel, List, ListItem } from '@mui/material';

import { theme } from '@/styles/colors';

interface Data {
  id: string;
  name: string;
}

interface CheckboxListProps {
  data: Data[];
  selectedData: Data[];
  setSelectedOptions: (data: Data[]) => void;
  allSelected: boolean;
}

const CheckboxList = ({
  data,
  selectedData,
  setSelectedOptions,
  allSelected,
}: CheckboxListProps) => {
  const handleClick = (checked: boolean, item: Data) => {
    if (!checked) {
      setSelectedOptions(selectedData.filter((sd) => sd.id !== item.id));
    } else {
      setSelectedOptions([...selectedData, item]);
    }
  };
  return (
    <List dense={true}>
      <ListItem key={'all'}>
        <FormControlLabel
          control={
            <Checkbox
              checked={allSelected}
              id="skill-all"
              sx={{
                '&.Mui-checked': {
                  color: theme.themeDefault,
                },
              }}
              onChange={(e, checked) => {
                if (!checked) {
                  setSelectedOptions([]);
                } else {
                  setSelectedOptions(data);
                }
              }}
            />
          }
          label="All"
          style={{ width: '100%' }}
        />
      </ListItem>
      {data.map((item) => (
        <ListItem key={item.id}>
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  !!selectedData.find((selected) => selected.id === item.id)
                }
                id={`skill-${item.id}`}
                sx={{
                  '&.Mui-checked': {
                    color: theme.themeDefault,
                  },
                }}
                onChange={(e, checked) => handleClick(checked, item)}
              />
            }
            label={item.name}
            style={{ width: '100%' }}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default CheckboxList;
